// Typed, single entry point to the dashboard dataset. Charts import their slice
// from here rather than reaching into the raw JSON.
import rawData from "../../../data/fifaDashboard.json";
import {FifaDashboardData} from "./types";

const fifaDashboard = rawData as unknown as FifaDashboardData;

export const {
  meta,
  overall,
  byTournament,
  byStage,
  byRankGap,
  thresholdSweep,
  hostEffect,
  semifinalists,
  biggestUpsets
} = fifaDashboard;

export default fifaDashboard;
export type {FifaDashboardData} from "./types";
